define((require) => {
    "use strict";

    var Browser      = require("shared/services/Browser"),
        EditorEvents = require("shared/services/EditorEvents"),
        ImprovedView = require("editor/zbone/ImprovedView"),
        template     = require("ui/common/URLBox.tpl"),
        UrlUtil      = require("shared/util/UrlUtil"),
        Window       = require("shared/services/Window");


    /**
     * Template for a "URL Box" with input element and open button.
     *
     * @author Jacob Midtgaard-Olesen (jmo@zmags.com)
     * @class URLBox
     * @constructor
     *
     * @cfg {String}    [urlProvider] The input element will be read only and contain the given URL
     */
    return ImprovedView.extend({

        classname: "urlBox",

        template: template,

        templateHelpers: function() {
            var key = Browser.os.macOS ? "\u2318" : "Ctrl";

            return {
                url: this.options.urlProvider() || "",
                helpText: this.options.helpText,
                button: key
            };
        },

        ui: {
            urlInput: "#url-input"
        },

        events: {
            "click .open-button": function() {
                var eventProperties = {
                    experienceUrl: this.options.urlProvider(),
                    triggerOrigin: this.options.triggerOrigin,
                    quickView: true,
                    projectId: this.options.project && this.options.project.get("id")
                };

                EditorEvents.trigger(EditorEvents.constants.OPEN_DIRECT_URL, eventProperties);

                this._openUrl();
            },
            "keypress #url-input": function(event) {
                if (event.keyCode === 13) {
                    this._openUrl();
                }
            }
        },

        onRender: function() {
            var url = this.options.urlProvider();

            if (url) {
                this.ui.urlInput.popover();
            }
        },

        _openUrl: function() {
            var url = this.ui.urlInput.val();

            Window.open(UrlUtil.prependHTTP(url));
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/common/URLBox.js